/**
 * An error thrown from operations within the {@link ContainerRegistry}.
 *
 * @group Errors
 *
 * @see {@link ContainerRegistry}
 */
export class ContainerRegistryError extends Error {
    constructor() {
        super(...arguments);
        this.name = 'ContainerRegistryError';
    }
}
//# sourceMappingURL=container-registry-error.error.js.map